/**
 * Generated runtime TestId mirror for frontend/src/pages/FormLayoutDesignerPage.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const FormLayoutDesignerPageTestIds = {
  conflictDialog: "conflict-dialog",
  conflictDiscardBtn: "conflict-discard-btn",
  conflictKeepEditingBtn: "conflict-keep-editing-btn",
  designerCancelBtn: "designer-cancel-btn",
  designerSaveBtn: "designer-save-btn",
  formLayoutDesignerPage: "form-layout-designer-page",
  unsavedChangesDialog: "unsaved-changes-dialog",
  unsavedChangesLeaveBtn: "unsaved-changes-leave-btn",
  unsavedChangesStayBtn: "unsaved-changes-stay-btn",
  usedOnPageLink: "used-on-page-link"
} as const;
